import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const bugsnag = defineConnector({
  identifier: "bugsnag",
  name: "BugSnag",
  tagLine: "Error monitoring and stability",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: () => "https://api\\.bugsnag\\.com/.*",
  auth: (app) =>
    headerAuth([
      { name: "Authorization", value: app.secret.authToken, scheme: "token" },
    ]),
  steps: [
    {
      title: "Create a personal auth token",
      items: [
        {
          kind: "markdown",
          content:
            "In [BugSnag](https://app.bugsnag.com/), open **My account › Personal auth tokens** and generate a new token.",
        },
      ],
    },
    {
      title: "Paste your auth token",
      items: [
        {
          kind: "input",
          label: "Personal auth token",
          required: true,
          target: { kind: "secrets", field: "authToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.bugsnag.com/user/organizations",
  },
});
